// Shared inline-style tokens for the settings panels. Keeps SettingsPage.tsx
// from re-declaring the same primaries everywhere and matches the look of
// the existing CRUD list rendered by SettingsTable.
import type { CSSProperties } from 'react';

export const sx: {
  card: CSSProperties;
  label: CSSProperties;
  input: CSSProperties;
  row: CSSProperties;
  btnPrimary: CSSProperties;
  btnSecondary: CSSProperties;
  btnDanger: CSSProperties;
  table: CSSProperties;
  th: CSSProperties;
  td: CSSProperties;
  hint: CSSProperties;
  badge: (color: string) => CSSProperties;
} = {
  card: {
    background: 'white',
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
  },
  label: {
    display: 'block',
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 4,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  input: {
    border: '1px solid #d1d5db',
    borderRadius: 4,
    padding: '6px 10px',
    fontSize: 13,
    width: '100%',
    boxSizing: 'border-box',
  },
  row: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    marginBottom: 8,
  },
  btnPrimary: {
    padding: '6px 12px',
    background: '#2563eb',
    color: 'white',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 13,
  },
  btnSecondary: {
    padding: '6px 12px',
    background: 'white',
    color: '#374151',
    border: '1px solid #d1d5db',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 13,
  },
  btnDanger: {
    padding: '4px 10px',
    background: 'white',
    color: '#dc2626',
    border: '1px solid #fca5a5',
    borderRadius: 6,
    cursor: 'pointer',
    fontSize: 12,
  },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { padding: '8px 4px', textAlign: 'left', color: '#6b7280' },
  td: { padding: '6px 4px', borderBottom: '1px solid #f3f4f6' },
  hint: { fontSize: 12, color: '#9ca3af', marginTop: 4 },
  badge: (color) => ({
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 10,
    background: color,
    color: 'white',
    fontSize: 11,
    fontWeight: 500,
  }),
};
